module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Media/Volume-half-07d5a14d13f72a2061b5f69e1aedb345.svg";